import React, { Component } from 'react';
import { Badge, Button, ButtonToolbar, Card, Col, Container, Form, Row, Table } from 'react-bootstrap';
import authService from '../api-authorization/AuthorizeService';
import { Link } from 'react-router-dom';
import { lightGreen } from '@material-ui/core/colors';
import { numberformat } from '../../DateHelper';
import Moment from 'react-moment';

const printIframe = (id) => {
    const iframe = document.frames
        ? document.frames[id]
        : document.getElementById(id);
    const iframeWindow = iframe.contentWindow || iframe;

    iframe.focus();
    iframeWindow.print();

    return false;
};

class InvoiceDetailBerOrTurbo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            InvoiceList: [], InvoiceDetailsById: [], customerDetail: {}, thd: {}, Balance: this.props.stotal, Credit: this.props.scredit,
            Payment: this.props.spayment, loading: true
        };
    }
    print() {
        var content = document.getElementById('printarea');
        var pri = document.getElementById('ifmcontentstoprint').contentWindow;
        pri.document.open();
        pri.document.write(content.innerHTML);
        pri.document.close();
        pri.focus();
        pri.print();
    }

    //print(layer) {
    //    var generator = window.open(",'name,");
    //    var laytext = document.getElementById(layer);
    //    generator.document.write(laytext.innerHTML.replace("Print me"));
    //    generator.document.close();
    //    generator.print();
    //    generator.close();
    //}

    render() {
        var txt;
        if (this.props.InvoiceCust.paymentOption == 0) {
            txt = 'NotSpecified'
        }
        else if (this.props.InvoiceCust.paymentOption == 1) {
            txt = 'Prepaid'
        }
        else if (this.props.InvoiceCust.paymentOption == 2) {
            txt = 'Consignment'
        }
        else if (this.props.InvoiceCust.paymentOption == 3) {
            txt = 'Net Terms'
        }
        var Balance = parseFloat(this.props.stotal) - parseFloat(this.props.scredit) - parseFloat(this.props.spayment)

        //this.setState({ Balance: this.props.stotal - (-(this.props.scredit) + (this.props.spayment)) });
        // else (this.props.InvoiceCust.paymentOption)
        return (
            <div className="thd-content-body thd-content-body-invoice bg-white" style={{ margin: "0px" }}>
                <table width="100%">
                    <tr>
                        <td align="center" className="text-center">
                            <Button variant="outline-secondary" onClick={() => { this.print() }}>
                                Print
                            </Button>
                        </td>
                    </tr>
                </table>
                <Card className="border-0 rounded-0 card-invoice" id="printarea">

                    <Card.Body>
                        <table cellPadding="5" cellSpacing="0" border="0" width="100%">
                            <tr>
                                <td>
                                    <div className="border-right thd-logo">
                                        <img src={'img/thd-logo.png'} alt="THD Logo" />
                                    </div>
                                </td>
                                <td>
                                    <div className="billed-from">
                                        <div className="invoice-content">
                                            <h3 className="mb-2">{this.props.InvoiceCust.firstName}{this.props.InvoiceCust.lastName}</h3>
                                            <p>
                                                {this.props.InvoiceCust.address1},<br />
                                                {this.props.InvoiceCust.address2},
                                            {this.props.InvoiceCust.address3}<br />
                                                {this.props.InvoiceCust.city} ,
                                            {this.props.InvoiceCust.stateProvince},
                                            {this.props.InvoiceCust.country},{this.props.InvoiceCust.zipPostalCode} <br />
                                                Tel No: {this.props.InvoiceCust.phoneNumber1} <br />
                                                Email: {this.props.InvoiceCust.email}
                                            </p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="invoice-header mb-5">
                                        <h1 className="invoice-title">Invoice</h1>
                                    </div>
                                </td>
                            </tr>
                        </table>


                        <table cellPadding="5" cellSpacing="0" border="0" width="100%">
                            <tr>
                                <td width="33%">
                                    <table width="100%">
                                        <tr>
                                            <td colSpan="">
                                                <label className="tx-gray-600"><b>Client</b></label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span className="">{this.props.InvoiceCust.company}</span></td>
                                        </tr>
                                        <tr>
                                            <td><span className="">C/o {this.props.InvoiceCust.firstName}{this.props.InvoiceCust.lastName} <br />

                                            </span></td>
                                        </tr>
                                    </table> 
                                </td>
                                <td width="25%"></td>
                                <td>
                                    <table width="100%">
                                        <tr>
                                            <td colSpan="2">
                                                <label className="tx-gray-600"><b>Invoice Information</b></label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span>Invoice No</span></td>
                                            <td align="right"><span className="text-right">{this.props.invoiceId}</span></td>
                                        </tr>
                                        <tr>
                                            <td style={{ borderTop: "1px dotted #9fa5ad" }}><span>Amount Due</span></td>
                                            <td style={{ borderTop: "1px dotted #9fa5ad" }} align="right"><span className="text-right">{Balance ? numberformat(Balance) : Balance}</span></td>
                                        </tr>
                                        <tr>
                                            <td style={{ borderTop: "1px dotted #9fa5ad" }}><span>Issue Date:</span></td>
                                            <td style={{ borderTop: "1px dotted #9fa5ad" }} align="right"><span className="text-right"><Moment format="MM/DD/YYYY">{this.props.Data.invoiceDate}</Moment></span></td>
                                        </tr>
                                        <tr>
                                            <td style={{ borderTop: "1px dotted #9fa5ad" }}><span>Terms:</span></td>
                                            <td style={{ borderTop: "1px dotted #9fa5ad" }} align="right"><span className="text-right">{txt}</span></td>
                                        </tr>
                                    </table>                                    
                                </td>
                            </tr>
                        </table>

                        <div className="mt-5">

                            <Table responsive size="xl" cellPadding="5" border="1" cellSpacing="0" width="100%" className="table-invoice">
                                <thead>
                                    <tr>
                                        <th colSpan="10" align="center" className="text-center datacol">Invoiced Items</th>
                                    </tr>
                                    <tr>
                                        <th>Facility</th>
                                        <th className="text-center" align="center">Shipment ID</th>
                                        <th className="text-center" align="center">BOL</th>
                                        <th className="text-center" align="center">Seal Number</th>
                                        <th className="text-center" align="center">ShipmentDate</th>
                                        <th className="text-center" align="center">Load Type</th>
                                        <th className="text-center" align="center">Unit Cost</th>
                                        <th className="text-center" align="center">Rate</th>
                                        <th className="text-center" align="center">QTY</th>
                                        <th className="text-center" align="center">Price</th>
                                    </tr>
                                </thead>
                                <tbody className="">
                                    {this.props.InvoiceList.map(berOrTurboManualInvoiceItemList => {
                                        if (!berOrTurboManualInvoiceItemList.isCredit && !berOrTurboManualInvoiceItemList.isPayment) {
                                            return (

                                                <tr key={berOrTurboManualInvoiceItemList.id} >
                                                    <td>{berOrTurboManualInvoiceItemList.warehouse}</td>
                                                    <td className="text-center" >{berOrTurboManualInvoiceItemList.shipmentId}</td>
                                                    <td className="text-center" >{berOrTurboManualInvoiceItemList.bol}</td>
                                                    <td className="text-center">{berOrTurboManualInvoiceItemList.sealNumber}</td>
                                                    <td className="text-center">{berOrTurboManualInvoiceItemList.shipmentDate}</td>
                                                    <td className="text-center">{this.props.invoiceType}</td>
                                                    <td className="text-center">{berOrTurboManualInvoiceItemList.unitCost ? numberformat(berOrTurboManualInvoiceItemList.unitCost) : berOrTurboManualInvoiceItemList.unitCost}</td>
                                                    <td className="text-center">{berOrTurboManualInvoiceItemList.rate}</td>
                                                    <td className="text-center">{berOrTurboManualInvoiceItemList.quantity}</td>
                                                    <td className="text-center">{berOrTurboManualInvoiceItemList.priceTotal ? numberformat(berOrTurboManualInvoiceItemList.priceTotal) : berOrTurboManualInvoiceItemList.priceTotal}</td>
                                                </tr>




                                            )
                                        }
                                    })}
                                </tbody>
                            </Table>
                            <Table responsive size="xl" cellPadding="5" border="1" cellSpacing="0" width="100%" className="table-invoice">
                                <thead>
                                    <tr>
                                        <th colSpan="10" align="center" className="text-center datacol">Credits</th>
                                    </tr>
                                    <tr>
                                        <th colSpan="2" className="text-center" align="center">Order #</th>
                                        <th colSpan="2" className="text-center" align="center">Description</th>
                                        <th colSpan="2" className="text-center" align="center">Credit Reason</th>
                                        <th colSpan="2" className="text-center" align="center">Credit Issue Date</th>
                                        <th colSpan="2" className="text-center" align="center">Credit Total</th>
                                    </tr>
                                </thead>
                                <tbody className="">
                                    {this.props.InvoiceList.map(berOrTurboManualInvoiceItemList => {
                                        if (berOrTurboManualInvoiceItemList.isCredit) {
                                            return (

                                                <tr key={berOrTurboManualInvoiceItemList.id}>
                                                    <td colSpan="2">{berOrTurboManualInvoiceItemList.orderNumber}</td>
                                                    <td colSpan="2" className="text-center" align="center">{berOrTurboManualInvoiceItemList.description}</td>
                                                    <td colSpan="2" className="text-center" align="center">{berOrTurboManualInvoiceItemList.creditReason}</td>
                                                    <td colSpan="2" className="text-center" align="center">{berOrTurboManualInvoiceItemList.shipmentDate}</td>
                                                    <td colSpan="2" className="text-center" align="center">{berOrTurboManualInvoiceItemList.priceTotal ? numberformat(berOrTurboManualInvoiceItemList.priceTotal) : berOrTurboManualInvoiceItemList.priceTotal}</td>
                                                </tr>

                                            )
                                        }
                                    })}
                                </tbody>
                            </Table>
                            <Table responsive size="xl" cellPadding="5" border="1" cellSpacing="0" width="100%" align="center" className="table-invoice">
                                <thead>
                                    <tr>
                                        <th colSpan="10" className="text-center datacol">Payments Applied</th>
                                    </tr>
                                    <tr>
                                        <th colSpan="5" className="text-center">Payment Date</th>

                                        <th colSpan="5" className="text-center" >Payment Amount</th>
                                    </tr>
                                </thead>
                                <tbody className="pheonixes">
                                    {this.props.InvoiceList.map(berOrTurboManualInvoiceItemList => {
                                        if (berOrTurboManualInvoiceItemList.isPayment) {
                                            return (

                                                <tr>
                                                    <td colSpan="5" className="text-center">{berOrTurboManualInvoiceItemList.shipmentDate}</td>
                                                    <td colSpan="5" className="text-center">{berOrTurboManualInvoiceItemList.priceTotal ? numberformat(berOrTurboManualInvoiceItemList.priceTotal) : berOrTurboManualInvoiceItemList.priceTotal}</td>
                                                </tr>

                                            )
                                        }
                                    })}
                                </tbody>
                                <tbody>
                                    <tr>
                                        <th colSpan="10" className="text-center datacol">Summary</th>
                                    </tr>
                                    <tr className="data">
                                        <td colSpan="7" className="blank">
                                            PLEASE ACH OR WIRE PAYMENT TO THE HOME DEPOT:
                    </td>
                                        <td colSpan="2" className="total-line">Total Invoiced</td>

                                        <td className="total-value"><div id="subtotal">{this.props.stotal ? numberformat(this.props.stotal) : this.props.stotal}</div></td>
                                    </tr>
                                    <tr className="data">
                                        <td colSpan="7" className="blank">
                                            Bank: Citibank, 111 Wall Street, New York, NY 10005
                    </td>
                                        <td colSpan="2" className="credit-line">Credits</td>

                                        <td className="total-value"><div id="totalcredits">{this.props.scredit ? numberformat(this.props.scredit) : this.props.scredit}</div></td>
                                    </tr>
                                    <tr className="data">
                                        <td colSpan="7" className="blank">
                                            Account Name: HOME DEPOTS USA INC. BRANDS DIRECT<br />
                                            Account Holder Address: 2455 Paces Ferry Rd SE, Atlanta, GA 30339
                   </td>
                                        <td colSpan="2" className="total-line">Payments Applied</td>

                                        <td className="total-value"><div id="totalpayments">{this.props.spayment ? numberformat(this.props.spayment) : this.props.spayment}</div></td>
                                    </tr>
                                    <tr className="data">
                                        <td colSpan="7" className="blank fill">
                                            Routing (ABA) #: 031100209 / Account #: 38741154<br /><br />
                                            Instructions: Please include Invoice/s in comments or reference field upon payment
                    </td>
                                        <td colSpan="2" className="total-line balance">Balance Due</td>

                                        <td className="total-value balance"><div className="due">{Balance ? numberformat(Balance) : Balance}</div></td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>

                        <hr className="mg-b-40" />
                        <div className="Thanku_Message mt-5">
                            <h6 className="mb-4">Please pay within {this.props.Data.netTermDays} days. Thank you for your business.</h6>
                            <h5 className="mb-2">TERMS AND CONDITIONS</h5>
                            <div className="footer-invoice">
                                <img src={'img/thd-logo.png'} alt="THD Logo" className="float-left mr-3" />
                                <p className="float-left"> Payment Terms.  All pricing and payments are and shall be in U.S. dollars. Purchaser shall make all payments for the Salvage Goods immediately to Home Depot by electronic funds transfer or with Home Depot’s preapproval, by bank certified check. No cash transactions are accepted. NOTICE: Once you have submitted the wire payment please email Salvage@homedepot.com so we can ensure your payment has been applied to the account accordingly.
                <br /><br />
                                    Disclaimer of Warranties. PURCHASER ACKNOWLEDGES AND AGREES THAT ALL SALVAGE GOODS ARE PURCHASED "AS IS," WITH NO WARRANTY OF ANY NATURE OR TYPE WHATSOEVER AND HEREBY DISCLAIMS ALL EXPRESS, IMPLIED, AND STATUTORY WARRANTIES, INCLUDING WITHOUT LIMITATION THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT, EXCEPT WARRANTY OF TITLE.
                <br /><br />
                                    Taxes. Purchaser is responsible for all taxes, tariffs, duties and applicable expenses based on any sales transactions occurring under this Agreement. Sales taxes will be added to the purchase price unless a copy of Purchaser's sales tax exemption agreement is received by Home Depot prior to purchase.
                <br /><br />
                                    Title and Risk of Loss. Title and risk of loss shall pass to Purchaser at the applicable Home Depot Repair and Liquidation Center. Purchaser is solely responsible for arranging for shipping and transportation and any further sale of all Salvage Goods, including, without limitation, shipping document preparation, proper packaging and labeling, and compliance with all laws, rules and regulations related thereto, including, without limitation, those relating to exporting  Any claims for shortage of Salvage Goods shipped must be received by Home Depot no more than (10) calendar days following the date of shipment. Home Depot shall have no responsibilities or liability for any such claims received after such ten (10) day period. Any claim for shortage of Salvage Goods must be received by Home Depot in writing within ten (10) calendar days of the date of shipment.
                <br /><br />
                                </p>
                            </div>
                        </div>


                    </Card.Body>
                </Card>
                <iframe id="ifmcontentstoprint" style={{
                                height: '0px',
                                width: '0px',
                                position: 'absolute'
                            }}></iframe>
                <table width="100%">
                    <tr>
                        <td align="center" className="text-center">
                            <Button variant="outline-secondary" onClick={() => { this.print() }}>
                                Print
                            </Button>
                        </td>
                    </tr>
                </table>
            </div>


        )
    }
}
export default InvoiceDetailBerOrTurbo;


